import React from 'react'

import { Div, Span } from '@driftt/tide-core'

export const EMPTY_DISPLAY = '—'
export const EMOJIS = Object.freeze({
  1: '😠',
  2: '🙁',
  3: '😐',
  4: '😊',
  5: '🤩',
})

export const renderLiveChatRating = (liveChatRating) => {
  if (!liveChatRating) {
    return <Span className="empty">{EMPTY_DISPLAY}</Span>
  }

  const emoji = EMOJIS[Math.floor(liveChatRating)]
  return (
    <Div className="table-team-perf--live-rating-container">
      <Div className="table-team-perf--live-rating-value">{liveChatRating}</Div>
      <Div className="table-team-perf--live-rating-emoji">{emoji}</Div>
    </Div>
  )
}
